import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb0373d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "input-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Randomize", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "method-wrapper" }
const _hoisted_6 = { open: "" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Century doomsday", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Calculate or "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://en.wikipedia.org/wiki/Doomsday_rule#Finding_a_year's_anchor_day",
    class: "external-link",
    rel: "noopener",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "memorize"),
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
      })
    ])
  ]),
  /*#__PURE__*/_createTextVNode(" the weekday of the century doomsday. ")
], -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Century doomsday is a ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Year doomsday", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Calculate the doomsday's weekday of the year, based on the last 2 digits of the target year "),
  /*#__PURE__*/_createElementVNode("i", null, "yy"),
  /*#__PURE__*/_createTextVNode(" and the century doomsday "),
  /*#__PURE__*/_createElementVNode("i", null, "cd"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" The year's doomsday weekday is a ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(". Remember this weekday for the last step. ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Doomsday dates ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("in a leap year")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Remember the doomsday dates for any given year and select the one that is closest to your date: ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "03.01. (or 04.01. for leap years)"),
  /*#__PURE__*/_createElementVNode("li", null, "last day of February"),
  /*#__PURE__*/_createElementVNode("li", null, "π day"),
  /*#__PURE__*/_createElementVNode("li", null, "\"I work 9-to-5 at 7-Eleven\""),
  /*#__PURE__*/_createElementVNode("li", null, "twin dates for 4, 6, 8, 10, 12")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " This means you have the following dates as doomsdays for your year: ", -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" The closest doomsday date is the ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Approaching target date", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Approach the target date from the closest doomsday date in 7-day steps. ", -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" The closest date with a doomsday weekday is the ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Difference to target date", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Calculate the difference in days from the closest date with a doomsday weekend to your target date. ", -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" The difference is ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Result", -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Take the year's doomsday weekday and add the day difference. If the difference is negative, you can add it to 7 and add that resulting value, e.g. ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" instead of ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" You have your final result! ")
const _hoisted_35 = { id: "result-options" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Practice", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Close the steps above, enter a (random) date and click on a weekday to verify your calculations! ", -1))
const _hoisted_38 = { id: "guesses" }
const _hoisted_39 = ["disabled", "onClick"]
const _hoisted_40 = {
  key: 1,
  class: "error"
}
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Input date is either invalid or out of bounds.")
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Enter a date between 01/01/1600 and 12/31/9999. ")
const _hoisted_44 = [
  _hoisted_41,
  _hoisted_42,
  _hoisted_43
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CenturyDoomsday = _resolveComponent("CenturyDoomsday")!
  const _component_YearDoomsday = _resolveComponent("YearDoomsday")!
  const _component_Formula = _resolveComponent("Formula")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputDate) = $event))
      }, null, 512), [
        [
          _vModelText,
          _ctx.inputDate,
          void 0,
          { lazy: true }
        ]
      ]),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.randomInputDate && _ctx.randomInputDate(...args))),
        "aria-label": "Use random input date"
      }, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.results != null)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("details", _hoisted_6, [
              _createElementVNode("summary", null, [
                _createElementVNode("h2", null, "Steps for " + _toDisplayString(_ctx.givenDate.toLocaleDateString()), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_7,
                _hoisted_8,
                _createVNode(_component_CenturyDoomsday, {
                  yyyy: _ctx.results.fullYear
                }, null, 8, ["yyyy"]),
                _createElementVNode("p", null, [
                  _hoisted_9,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.weekDays[_ctx.results.centuryDoomsday]) + " (" + _toDisplayString(_ctx.results.centuryDoomsday) + ")", 1),
                  _hoisted_10
                ]),
                _hoisted_11,
                _hoisted_12,
                _createVNode(_component_YearDoomsday, {
                  yy: _ctx.results.fullYear % 100,
                  cd: _ctx.results.centuryDoomsday
                }, null, 8, ["yy", "cd"]),
                _createElementVNode("p", null, [
                  _hoisted_13,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.weekDays[_ctx.results.yearDoomsday]) + " (" + _toDisplayString(_ctx.results.yearDoomsday) + ")", 1),
                  _hoisted_14
                ]),
                _createElementVNode("h3", null, [
                  _hoisted_15,
                  (_ctx.results.isInputLeapYear)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_16
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_17,
                _hoisted_18,
                _hoisted_19,
                _createVNode(_component_Formula, {
                  formula: 
                _ctx.results.doomsdays
                  .slice(0, 6)
                  .map((day) => _ctx.format(day))
                  .join(', ') + ','
              
                }, null, 8, ["formula"]),
                _createVNode(_component_Formula, {
                  formula: 
                _ctx.results.doomsdays
                  .slice(6)
                  .map((day) => _ctx.format(day))
                  .join(', ')
              
                }, null, 8, ["formula"]),
                _createElementVNode("p", null, [
                  _hoisted_20,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.results.closestDoomsday.toLocaleDateString()), 1),
                  _hoisted_21
                ]),
                _hoisted_22,
                _hoisted_23,
                _createVNode(_component_Formula, {
                  formula: 
                _ctx.results.stepsFromDoomsdayToInput
                  .map((step) => _ctx.format(step))
                  .join(' \\rightarrow ')
              
                }, null, 8, ["formula"]),
                _createElementVNode("p", null, [
                  _hoisted_24,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.results.closestStepDate.toLocaleDateString()), 1),
                  _hoisted_25
                ]),
                _hoisted_26,
                _hoisted_27,
                _createVNode(_component_Formula, { formula: 'closest \\rightarrow input = \\Delta \\ days' }),
                _createVNode(_component_Formula, {
                  formula: 
                _ctx.results.closestStepDate.toLocaleDateString() +
                ' \\rightarrow ' +
                _ctx.givenDate.toLocaleDateString() +
                ' = ' +
                (_ctx.results.daysDiffToClosestDoomsday > 0 ? '+' : '') +
                _ctx.results.daysDiffToClosestDoomsday +
                ' \\ ' +
                (_ctx.abs(_ctx.results.daysDiffToClosestDoomsday) === 1 ? 'day' : 'days')
              
                }, null, 8, ["formula"]),
                _createElementVNode("p", null, [
                  _hoisted_28,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.results.daysDiffToClosestDoomsday > 0 ? "+" : "") + _toDisplayString(_ctx.results.daysDiffToClosestDoomsday) + " " + _toDisplayString(_ctx.abs(_ctx.results.daysDiffToClosestDoomsday) === 1 ? "day" : "days"), 1),
                  _hoisted_29
                ]),
                _hoisted_30,
                _createElementVNode("p", null, [
                  _hoisted_31,
                  _createVNode(_component_Formula, {
                    formula: "+1",
                    inline: ""
                  }),
                  _hoisted_32,
                  _createVNode(_component_Formula, {
                    formula: "-6",
                    inline: ""
                  }),
                  _hoisted_33
                ]),
                _createVNode(_component_Formula, { formula: "yd + \\Delta = result" }),
                _createVNode(_component_Formula, {
                  formula: 
                _ctx.weekDays[_ctx.results.yearDoomsday] +
                '\\ (' +
                _ctx.results.yearDoomsday +
                ') ' +
                (_ctx.results.daysDiffToClosestDoomsday < 0 ? '- ' : '+ ') +
                _ctx.abs(_ctx.results.daysDiffToClosestDoomsday) +
                ' = ' +
                _ctx.weekDays[_ctx.results.result] +
                '\\ (' +
                _ctx.results.result +
                ') '
              
                }, null, 8, ["formula"]),
                (_ctx.results.daysDiffToClosestDoomsday < 0)
                  ? (_openBlock(), _createBlock(_component_Formula, {
                      key: 0,
                      formula: 
                  _ctx.weekDays[_ctx.results.yearDoomsday] +
                  '\\ (' +
                  _ctx.results.yearDoomsday +
                  ') + ' +
                  _ctx.abs(7 + _ctx.results.daysDiffToClosestDoomsday) +
                  ' = ' +
                  _ctx.weekDays[_ctx.results.result] +
                  '\\ (' +
                  _ctx.results.result +
                  ') '
                
                    }, null, 8, ["formula"]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, [
                  _hoisted_34,
                  _createElementVNode("strong", null, "The " + _toDisplayString(_ctx.givenDate.toLocaleDateString()) + " is a " + _toDisplayString(_ctx.weekDays[_ctx.results.result]) + ".", 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDayNumbers, (weekday) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: weekday,
                    class: _normalizeClass(_ctx.resultOptionsState[weekday]),
                    disabled: _ctx.results == null,
                    onClick: ($event: any) => (_ctx.check(weekday))
                  }, _toDisplayString(_ctx.weekDays[weekday]), 11, _hoisted_39))
                }), 128))
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("p", _hoisted_40, _hoisted_44))
    ])
  ]))
}